module.exports = __webpack_public_path__ + "static/media/Meda - Ind.Blue_Peri.786f6d26.jpg";